import React, { FC, ReactNode } from "react";
import { Box, Tooltip, TooltipProps } from "@chakra-ui/react";

type SyncoTooltipProps = {
  label: ReactNode;
  wrapInBox?: boolean;
} & TooltipProps;

const SyncoTooltip: FC<SyncoTooltipProps> = ({
  children,
  wrapInBox = true,
  ...rest
}) => (
  // Wrapping in Box that way we don't have to worry about forwardRef (e.g. when using an Icon)
  <Tooltip hasArrow borderRadius={5} p={3} {...rest}>
    {wrapInBox ? <Box>{children}</Box> : children}
  </Tooltip>
);

export default SyncoTooltip;
